<header>
    <nav class="navbar navbar-expand-lg fixed-top" (click)="keepNavbarMenuOpen($event)">
        <div class="container site-navbar__container">
            <a class="navbar-brand fw-bold" routerLink="/" (click)="handleNavigationClick()">
                <img src="/favicon-inverse.svg" alt="Logo" width="48" height="48"
                     class="d-inline-block align-text-top">
                <span class="brand-copy">
                    <span class="brand-name">
                        Motor<span class="text-danger">Desk</span>
                    </span>
                    <span class="brand-caption">Учет авто без хаоса</span>
                </span>
            </a>
            <button class="navbar-toggler navbar-toggler" type="button"
                    aria-controls="navbarSupportedContent"
                    [attr.aria-expanded]="isNavbarMenuOpen"
                    aria-label="Toggle navigation"
                    (click)="toggleNavbarMenu($event)">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent"
                 [ngClass]="{'show': isNavbarMenuOpen}">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="APP_ROUTES.INDEX" (click)="handleNavigationClick()">
                            <svg class="nav-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.home" [size]="16"></svg>
                            {{ NAVS.INDEX }}
                        </a>
                    </li>
                    <li class="nav-item nav-item--dropdown"
                        [ngClass]="{'is-open': isFeaturesMenuOpen, 'is-hover-suppressed': suppressFeaturesHover}">
                        <div class="nav-dropdown">
                            <button class="nav-link nav-link--dropdown" type="button"
                                    (click)="toggleFeaturesMenu($event)">
                                <span>
                                    <svg class="nav-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.grid" [size]="16"></svg>
                                    {{ NAVS.FEATURES.INDEX }}
                                    <svg class="nav-link__caret" [lucideIcon]="APP_LUCIDE_ICONS.chevronDown"
                                         [size]="15"></svg>
                                </span>
                            </button>
                            <div class="nav-dropdown__menu">
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.FEATURES.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.grid"
                                         [size]="17"></svg>
                                    {{ NAVS.FEATURES.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.MAINTENANCE.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.wrench"
                                         [size]="17"></svg>
                                    {{ NAVS.MAINTENANCE.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.SERVICE_PROVIDERS.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.mapPin"
                                         [size]="17"></svg>
                                    {{ NAVS.SERVICE_PROVIDERS.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.PLAN.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.calendarCheck"
                                         [size]="17"></svg>
                                    {{ NAVS.PLAN.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.FUEL.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.droplet"
                                         [size]="17"></svg>
                                    {{ NAVS.FUEL.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.MILEAGE.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.chart"
                                         [size]="17"></svg>
                                    {{ NAVS.MILEAGE.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.NOTES.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.fileText"
                                         [size]="17"></svg>
                                    {{ NAVS.NOTES.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.MONEY.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.creditCard"
                                         [size]="17"></svg>
                                    {{ NAVS.MONEY.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.BOT.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.send"
                                         [size]="17"></svg>
                                    {{ NAVS.BOT.INDEX }}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item nav-item--dropdown"
                        [ngClass]="{'is-open': isToolsMenuOpen, 'is-hover-suppressed': suppressToolsHover}">
                        <div class="nav-dropdown">
                            <button class="nav-link nav-link--dropdown" type="button"
                                    (click)="toggleToolsMenu($event)">
                                <span>
                                    <svg class="nav-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.calculator"
                                         [size]="16"></svg>
                                    {{ NAVS.TOOLS.INDEX }}
                                    <svg class="nav-link__caret" [lucideIcon]="APP_LUCIDE_ICONS.chevronDown"
                                         [size]="15"></svg>
                                </span>
                            </button>
                            <div class="nav-dropdown__menu">
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.TOOLS.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.calculator"
                                         [size]="17"></svg>
                                    {{ NAVS.TOOLS.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.TRIP_CALCULATOR.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.calculator"
                                         [size]="17"></svg>
                                    {{ NAVS.TRIP_CALCULATOR.INDEX }}
                                </a>
                                <a class="nav-dropdown__item" [routerLink]="APP_ROUTES.ROUTE_DISTANCE.INDEX"
                                   (click)="handleNavigationClick()">
                                    <svg class="nav-dropdown__icon" [lucideIcon]="APP_LUCIDE_ICONS.mapPin"
                                         [size]="17"></svg>
                                    {{ NAVS.ROUTE_DISTANCE.INDEX }}
                                </a>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="APP_ROUTES.DEMO.INDEX" (click)="handleNavigationClick()">
                            <svg class="nav-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.monitor" [size]="16"></svg>
                            {{ NAVS.DEMO.INDEX }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="APP_ROUTES.BLOG.INDEX" (click)="handleNavigationClick()">
                            <svg class="nav-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.fileText" [size]="16"></svg>
                            {{ NAVS.BLOG.INDEX }}
                        </a>
                    </li>
                </ul>
                <div class="site-navbar__actions my-3 my-lg-0">
                    <a class="site-navbar__login" [href]="env.URL_LK" (click)="trackLoginClick('header')">
                        Войти
                    </a>
                    <a class="btn btn-danger no-wrap border-radius-rounded"
                       [href]="registrationUrl('header')"
                       (click)="trackRegistrationClick('header')">
                        <svg class="button-icon" [lucideIcon]="APP_LUCIDE_ICONS.logIn" [size]="17"></svg>
                        Создать кабинет
                    </a>
                </div>
            </div>
        </div>
    </nav>
</header>

<main>
    <div class="main-shell">
        <router-outlet/>
    </div>
</main>

<footer class="site-footer">
    <div class="container footer-shell">
        <div class="row g-4 footer-top align-items-start">
            <div class="col-xl-5 col-lg-6">
                <div class="footer-brand-block">
                    <a class="navbar-brand fw-bold mb-0" routerLink="/">
                        <img src="/favicon-inverse.svg" alt="Logo" width="48" height="48"
                             class="d-inline-block align-text-top">
                        <span class="brand-name">
                            Motor<span class="text-danger">Desk</span>
                        </span>
                    </a>
                    <span class="footer-badge">Учет автомобиля без хаоса</span>
                    <p class="footer-lead mb-0">
                        MotorDesk помогает вести историю обслуживания, план ТО, заправки, пробег,
                        денежные расходы и быстрые сценарии через Telegram-бот в одном личном кабинете.
                    </p>
                </div>
            </div>
            <div class="col-xl-7 col-lg-6">
                <div class="footer-card">
                    <p class="footer-card-label mb-2">Быстрый старт</p>
                    <h2 class="footer-card-title">
                        Создайте кабинет и начните вести расходы, обслуживание и историю автомобиля в одном месте
                    </h2>
                    <p class="footer-card-note">Для регистрации нужен e-mail в зоне .ru.</p>
                    <div class="footer-actions">
                        <a class="btn btn-danger no-wrap border-radius-rounded"
                           [href]="registrationUrl('footer')"
                           (click)="trackRegistrationClick('footer')">
                            <svg class="button-icon" [lucideIcon]="APP_LUCIDE_ICONS.logIn" [size]="17"></svg>
                            Создать кабинет
                        </a>
                        <a class="footer-inline-link" [href]="env.URL_LK" (click)="trackLoginClick('footer')">Войти</a>
                        <a class="footer-inline-link" href="mailto:{{env.CONTACT_EMAIL}}">
                            <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.mail" [size]="17"></svg>
                            {{ env.CONTACT_EMAIL }}
                        </a>
                        <a class="footer-inline-link" [href]="env.CHANNEL_URL" target="_blank" rel="noopener">
                            <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.send" [size]="17"></svg>
                            Новости в {{ env.CHANNEL_NAME }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row g-4 footer-links-row">
            <div class="col-lg-3">
                <div class="footer-nav-group">
                    <h2 class="footer-nav-title">Сервис</h2>
                    <ul class="footer-links">
                        <li>
                            <a [routerLink]="APP_ROUTES.FEATURES.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.grid" [size]="17"></svg>
                                {{ NAVS.FEATURES.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.TOOLS.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.calculator"
                                     [size]="17"></svg>
                                {{ NAVS.TOOLS.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.DEMO.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.monitor"
                                     [size]="17"></svg>
                                {{ NAVS.DEMO.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.BLOG.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.fileText"
                                     [size]="17"></svg>
                                {{ NAVS.BLOG.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [href]="env.CHANNEL_URL" target="_blank" rel="noopener">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.send" [size]="17"></svg>
                                Telegram-канал
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="footer-nav-group">
                    <h2 class="footer-nav-title">Обслуживание</h2>
                    <ul class="footer-links">
                        <li>
                            <a [routerLink]="APP_ROUTES.MAINTENANCE.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.wrench" [size]="17"></svg>
                                {{ NAVS.MAINTENANCE.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.SERVICE_PROVIDERS.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.mapPin"
                                     [size]="17"></svg>
                                {{ NAVS.SERVICE_PROVIDERS.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.PLAN.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.calendarCheck"
                                     [size]="17"></svg>
                                {{ NAVS.PLAN.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.MONEY.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.creditCard"
                                     [size]="17"></svg>
                                {{ NAVS.MONEY.INDEX }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="footer-nav-group">
                    <h2 class="footer-nav-title">Повседневные задачи</h2>
                    <ul class="footer-links">
                        <li>
                            <a [routerLink]="APP_ROUTES.FUEL.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.droplet"
                                     [size]="17"></svg>
                                {{ NAVS.FUEL.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.TRIP_CALCULATOR.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.calculator"
                                     [size]="17"></svg>
                                {{ NAVS.TRIP_CALCULATOR.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.ROUTE_DISTANCE.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.mapPin"
                                     [size]="17"></svg>
                                {{ NAVS.ROUTE_DISTANCE.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.MILEAGE.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.chart" [size]="17"></svg>
                                {{ NAVS.MILEAGE.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.NOTES.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.fileText"
                                     [size]="17"></svg>
                                {{ NAVS.NOTES.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.BOT.INDEX">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.send" [size]="17"></svg>
                                {{ NAVS.BOT.INDEX }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3">
                <div class="footer-nav-group">
                    <h2 class="footer-nav-title">Документы</h2>
                    <ul class="footer-links">
                        <li>
                            <a [routerLink]="APP_ROUTES.PRIVACY.INDEX" rel="nofollow">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.shield" [size]="17"></svg>
                                {{ NAVS.PRIVACY.INDEX }}
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="APP_ROUTES.AGREEMENT.INDEX" rel="nofollow">
                                <svg class="footer-link__icon" [lucideIcon]="APP_LUCIDE_ICONS.fileText"
                                     [size]="17"></svg>
                                {{ NAVS.AGREEMENT.INDEX }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <p>&copy; MotorDesk 2024-{{ currentYear }}</p>
            <p>Powered by <a href="https://volego.ru" rel="nofollow">volego.ru</a></p>
        </div>
    </div>
</footer>
